import { z } from 'zod';

export const schema = z.object({
  skills: z.array(z.string()),
  behaviors: z.array(z.string()),
});

export type ZodSchema = typeof schema;
export type Schema = z.infer<ZodSchema>;
